<div id="festive-banner" class="container-fluid">
  <div class="festive-wrap">
    <div class="festive-item">
      <a [routerLink]="['/','nova-godina']">
        <img
          src="../../../assets/images/special banners/top-line-title.jpg"
          alt=""
        />
      </a>
    </div>
    <div class="festive-item">
      <a [href]="'https://sofia.zavedenia.com/4303/Gradski-Legendi-Steak-and-Fish-House/offers/63793/Nova-godina-v-Gradski-Legendi'">
        <img
          src="https://zavedenia.com/_images/top-line-gradski.jpg"
          alt=""
        />
      </a>
    </div>
    <div class="festive-item mobile-hide">
      <a href="https://sofia.zavedenia.com/4446/Restorant-Anatolia---Anatolia-restaurant/offers/63521/Nova-Godina-2025-v-restorant-Anatolia">
        <img
          src="../../../assets/images/special banners/topny1.jpg"
          alt=""
        />
      </a>
    </div>
    <!-- <div class="festive-item">
      <a [href]="'https://sofia.zavedenia.com/3123/Egur-Egur--armenski-restorant/offers/59998/NOVOGODIShEN-KUVERT-2025'">
        <img
          src="../../../assets/images/special banners/top-line-egur.jpg"
          alt=""
        />
      </a>
    </div> -->
    <div class="festive-item">
      <a [href]="'https://sofia.zavedenia.com/1609/Mehana-Sofiya/offers/19098/Nova-godina-v-mehana-Sofiya-----140-lv'">
        <img
          src="../../../assets/images/special banners/topline-mehanasofia.jpg"
          alt=""
        />
      </a>
    </div>
    <div class="festive-item">
      <a [href]="'https://sofia.zavedenia.com/1577/Ruski-restorant-ARBAT/offers/60346/NOVA-GODINA-V-RESTORANT-ARBAT'">
        <img
          src="../../../assets/images/special banners/top-line-arbat.jpg"
          alt=""
        />
      </a>
    </div>
    <div class="festive-item mobile-hide">
      <a [routerLink]="['/','nova-godina']">
        <img
          src="../../../assets/images/special banners/top-line-all.jpg"
          alt=""
        />
      </a>
    </div>

  </div>
</div>
